import { IPermissionModel } from './';

export const KAENCPermissions: IPermissionModel[] = [
	//Dashboard
	{
		name: 'Dashboard',
		route: '/',
		components: [],
	},
	{ name: 'Dashboard KAE', route: '/dashboard-kaerr', components: ['kae-role'] },
	{ name: 'Details Summary', route: '/dashboard-kaenc-details', components: [] },

	//Others
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'PCMS', route: '/pcms', components: [] },
	{ name: 'HelpAndSupport', route: '/help-and-support', components: [] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },

	//Member
	{ name: 'Leads', route: '/leads', components: [] },
	{ name: 'End Users', route: '/end-users', components: [] },
	{ name: 'End User Basic Details', route: '/end-user/basic-details', components: [] },
	{ name: 'End User More Details', route: '/end-user/more-details', components: [] },
	{ name: 'Create Lead', route: '/lead', components: [] },
	{ name: 'Basic Details', route: '/lead/basic-details', components: [] },
	{ name: 'More Details', route: '/lead/more-details', components: [] },
	{ name: 'User 360', route: '/contractor', components: [] },
	{ name: 'Competition', route: '/contractor/competition-details', components: [] },

	//Banking
	{ name: 'Qr Code Scanner', route: '/contractor/qr-code-scanner', components: [] },
	{ name: 'Banking History', route: '/contractor/banking-history', components: [] },
	{ name: 'Redemption History', route: '/contractor/redemption-history', components: [] },
	{ name: 'Points History', route: '/contractor/points-statement', components: [] },
	{ name: 'Qr Code Check', route: '/contractor/qr-code-check', components: [] },
	{ name: 'Qr Code Validate', route: '/contractor/qr-code-validate', components: [] },
	{ name: 'Points Dashboard', route: '/contractor/points-dashboard', components: [] },

	//KYC
	{ name: 'Physical Verification', route: '/contractor/physical-verification', components: [] },
	{ name: 'KYC Verification', route: '/kyc-verification', components: [] },
	{ name: 'Identity Verification', route: '/identity-verification', components: [] },
	{ name: 'Upload Document', route: '/identity-verification/upload-document', components: [] },
	{ name: 'Selfie Verification', route: '/identity-verification/selfie-verification', components: [] },
	{ name: 'Bank Details', route: '/bank-details', components: [] },

	//Calender
	{ name: 'Calendar', route: '/calendar', components: [] },

	//One To One Meeting
	{ name: 'Add One To One Meeting', route: '/one-to-one-meeting/add', components: [] },
	{ name: 'Edit One To One Meeting', route: '/one-to-one-meeting/edit', components: [] },
	{ name: 'Stakeholder Details', route: '/add-meeting-stackholder/stakeholder-details', components: [] },
	{ name: 'Add Meeting Schedule', route: '/add-meeting-stackholder/add-meeting-schedule', components: [] },
	{ name: 'One To One Meeting', route: '/one-to-one-meeting', components: [] },
	{ name: 'Product Discussion Demo', route: '/product-discussion-demo', components: [] },
	{ name: 'Scheme Discussion', route: '/scheme-discussion', components: [] },
	{ name: 'Complaint Handling', route: '/complaint-handling', components: [] },
	{ name: 'Relationship Building', route: '/relationship-building', components: [] },
	{ name: 'Market Feedback', route: '/market-feedback', components: [] },
	{ name: 'Lead Generation', route: '/lead-generation', components: [] },
	{ name: 'Product Recommendation', route: '/product-recommendation', components: [] },

	//One to Many Meeting
	{ name: 'Meetings', route: '/meetings', components: [] },
	{ name: 'Scheduled Meetings', route: '/meetings/scheduled-meetings', components: [] },
	{ name: 'Today&apos;s Meetings', route: '/meetings/todays-meetings', components: [] },
	{ name: 'All Meetings', route: '/meetings/all-meetings', components: [] },
	{ name: 'Add New Meeting', route: '/meeting', components: [] },
	{ name: 'Add Meeting Details', route: '/meeting/meeting-details', components: [] },
	{ name: 'Add Meeting Participants', route: '/meeting/meeting-participants', components: [] },
	{ name: 'Today Meetings', route: '/today-meetings', components: [] },
	{ name: 'Meeting Details', route: '/meeting-details', components: [] },
	{ name: 'Send Feedback', route: '/send-feedback', components: [] },
	{ name: 'Send Expense Details', route: '/send-expense-details', components: [] },
	{ name: 'Meeting Completed', route: '/complete-meeting', components: [] },
	{ name: 'Complete Meeting Details', route: '/complete-meeting-details', components: [] },

	//User Transfer
	{ name: 'User Transfer', route: '/user-transfer', components: [] },
	{ name: 'User Transfer Request', route: '/user-transfer/request', components: [] },
	{ name: 'User Transfer Approved', route: '/user-transfer/approved', components: [] },
	{ name: 'User Transfer Rejected', route: '/user-transfer/rejected', components: [] },

	//Case Module
	{ name: 'Case Module', route: '/case-module', components: [] },
	{ name: 'Case Module Details', route: '/case-module-details', components: [] },

	//DFCC Clubs
	{ name: 'DFCC Clubs', route: '/dfcc-clubs', components: [] },
	{ name: 'DFCC Details', route: '/dfcc-clubs/club-details', components: [] },
	{ name: 'Transfer Member', route: '/dfcc-clubs/transfer-member', components: [] },
	{ name: 'Select Club Member', route: '/dfcc-clubs/select-club-member', components: [] },

	//Prospective Site
	{ name: 'Add Prospective Site', route: '/add-prospective-site', components: [] },
	{ name: 'Add New Site', route: '/add-new-site', components: [] },
	{ name: 'Basic Details', route: '/add-new-site/basic', components: [] },
	{ name: 'Surface Details', route: '/add-new-site/surface', components: [] },
	{ name: 'Prospective Site', route: '/prospective-site', components: [] },

	//Site
	{ name: 'Site Details', route: '/site-details', components: [] },
	{ name: 'Site 360', route: '/site-details-rr', components: [] },
	{ name: 'Stakeholder Mapping', route: '/stakeholder-mapping', components: [] },
	{ name: 'Site List', route: '/sites', components: [] },
	{ name: 'Product Sampling', route: '/product-sampling-add', components: [] },
	{ name: 'Site Log Visit', route: '/site-log-visit', components: [] },
	{ name: 'Product Sampling List', route: '/product-sampling-list', components: [] },
	{ name: 'Sampling Request', route: '/product-sampling-list/sampling-request', components: [] },
	{ name: 'Raincoat Preview', route: '/product-sampling-list/raincoat-preview', components: [] },
	{ name: 'Add Raincoat Preview', route: '/raincoat-preview-add', components: [] },
	{ name: 'Raincoat Preview Detail', route: '/raincoat-preview-detail', components: [] },
	{ name: 'Product Sampling Detail', route: '/product-sampling-detail', components: [] },
	{ name: 'Generate DR', route: '/generated-dr', components: [] },
	{ name: 'Generate DR Report', route: '/generated-dr-report', components: [] },
	{ name: 'Site Log Visit', route: '/site-log-visit', components: [] },
	{ name: 'Recommendation Report', route: '/recommendation-report', components: [] },
	{ name: 'Business Generate', route: '/business-generated', components: [] },

	{ name: 'Feedback Questionnaires', route: '/feedback-questionnaires', components: [] },
];
